export default "__VITE_ASSET__D_Soy5KK__"